import { SERIE_B_2026 } from './serie-b-2026';

/** Estádios (nomes reais) dos 20 clubes da Série A 2026, pela sigla do clube. */
const ESTADIOS: Record<string, string> = {
  FLA: 'Maracanã',
  FLU: 'Maracanã',
  BOT: 'Nilton Santos',
  VAS: 'São Januário',
  PAL: 'Allianz Parque',
  COR: 'Neo Química Arena',
  SAO: 'MorumBIS',
  SAN: 'Vila Belmiro',
  MIR: 'Maião',
  RBB: 'Nabi Abi Chedid',
  CRU: 'Mineirão',
  CAM: 'Arena MRV',
  GRE: 'Arena do Grêmio',
  INT: 'Beira-Rio',
  CTB: 'Couto Pereira',
  CAP: 'Ligga Arena',
  CHA: 'Arena Condá',
  BAH: 'Arena Fonte Nova',
  VIT: 'Barradão',
  REM: 'Mangueirão',
  // clubes estrangeiros da Libertadores
  RIV: 'Monumental de Núñez',
  BOC: 'La Bombonera',
  ROS: 'Gigante de Arroyito',
  RAC: 'El Cilindro',
  LAN: 'Ciudad de Lanús',
  VEL: 'José Amalfitani',
  PEN: 'Campeón del Siglo',
  NAC: 'Gran Parque Central',
  ATN: 'Atanasio Girardot',
  MIL: 'El Campín',
  JUN: 'Metropolitano Roberto Meléndez',
  COL: 'Monumental David Arellano',
  UCA: 'San Carlos de Apoquindo',
  UCH: 'Estadio Nacional',
  OLI: 'Defensores del Chaco',
  CER: 'La Nueva Olla',
  LIB: 'La Huerta',
  LDU: 'Rodrigo Paz Delgado',
  BSC: 'Monumental Banco Pichincha',
  IDV: 'Banco Guayaquil',
  UNI: 'Monumental de Lima',
  ALI: 'Alejandro Villanueva',
  BOL: 'Hernando Siles',
  STR: 'Rafael Mendoza',
  CAR: 'Misael Delgado',
  TAC: 'Pueblo Nuevo',
};

/** Nome do estádio do clube (nome real quando conhecido; senão "Estádio <sigla>"). */
export function nomeEstadio(c: { sigla: string; nome?: string; liga?: string; estadio?: string }): string {
  // clube de liga estrangeira: a sigla pode coincidir com a de um clube brasileiro, então não serve de chave
  if (c.liga) return c.estadio ?? `Estádio do ${c.nome ?? c.sigla}`;
  return ESTADIOS[c.sigla] ?? SERIE_B_2026.find((b) => b.sigla === c.sigla)?.estadio ?? `Estádio ${c.sigla}`;
}

/** Capacidade oficial (lugares) do estádio de cada clube, pela sigla. Clube fora da lista usa a capacidade gerada pela reputação. */
const CAPACIDADES: Record<string, number> = {
  FLA: 78_838,
  FLU: 78_838,
  SAO: 66_795,
  FOR: 63_903,
  CEA: 63_903,
  CRU: 61_927,
  GRE: 55_662,
  INT: 50_128,
  BAH: 50_025,
  COR: 47_605,
  CAM: 46_000,
  BOT: 44_661,
  PAL: 43_713,
  CAP: 42_372,
  VIT: 30_793,
  VAS: 21_880,
  JUV: 19_924,
  CRI: 19_225,
  RBB: 17_022,
  SAN: 16_068,
  ACG: 12_500,
  REM: 50_000,
  SPO: 42_600,
  CTB: 40_502,
  LON: 31_000,
  BSP: 28_743,
  AME: 23_018,
  CHA: 20_069,
  CRB: 19_105,
  AVA: 17_800,
  PON: 17_728,
  NOV: 16_000,
  MIR: 15_000,
  GOI: 14_525,
  VIL: 11_788,
  OPE: 10_632,
  RIV: 83_214,
  BOC: 54_000,
  ROS: 41_654,
  RAC: 51_389,
  LAN: 47_027,
  VEL: 49_540,
  PEN: 40_000,
  NAC: 34_000,
  ATN: 44_000,
  MIL: 36_343,
  JUN: 46_692,
  COL: 47_347,
  UCA: 14_118,
  UCH: 48_665,
  OLI: 42_354,
  CER: 45_000,
  LIB: 10_000,
  LDU: 41_575,
  BSC: 57_267,
  IDV: 12_000,
  UNI: 80_093,
  ALI: 35_000,
  BOL: 41_143,
  STR: 10_000,
  CAR: 10_000,
  TAC: 38_755,
};

/** Capacidade real do estádio do clube, ou undefined se não houver dado. */
export function capacidadeOficial(sigla: string): number | undefined {
  return CAPACIDADES[sigla];
}
